import { emptyDatiqModal, IDatiqModal } from '@dat/datiq-components-pkg/modal';
import { z } from 'zod';

export interface IIqMcModalStateService {}

export interface IIqMcXmaModalData {
    code: string;
    name: string;
    fillColor: string;
}

export interface IIqMcModalMci {
    title: string;
    primarySection?: IIqMcModalMciSection;
    secondarySection?: IIqMcModalMciSection;
    footerSection?: IIqMcModalMciSection;
    modalSettings: IDatiqModal;
}

export interface IIqMcModalMciSection {
    title?: string;
    description?: string;
    image?: string;
    imageAlt?: string;
    link?: string;
}

export const emptyXmaModalData: IIqMcXmaModalData = {
    code: '',
    name: '',
    fillColor: '#fff',
};

export const iqMcXmaModalTitle: string = 'Select Extended Market Area';

export const emptyIqMcModalSection: IIqMcModalMciSection = {
    title: '',
    description: '',
    image: '',
    imageAlt: '',
    link: '',
};

export const emptyIqMcModalMci: IIqMcModalMci = {
    title: '',
    primarySection: emptyIqMcModalSection,
    secondarySection: emptyIqMcModalSection,
    footerSection: emptyIqMcModalSection,
    modalSettings: emptyDatiqModal,
};

export const iqMcModalTitle: string =
    'What is the Market Conditions Index (MCI)?';

export const iqMcModalPrimarySection: IIqMcModalMciSection = {
    description:
        'MCI includes seasonal trends, historical market activity, and unique post and search behaviour. The result is an accurate, universally applicable measure of capacity ',
    image: 'assets/mc-modal-gaugekey.png',
    imageAlt: 'MCI Gauge Key',
};

export const iqMcModalSecondarySection: IIqMcModalMciSection = {
    title: "Easily compare one market's activity to another",
    description:
        'MCI is a more useful measure than the L/T Ratio. Compare the two regions below. Their L/T Ratios are very similar, but the activity across markets vary widely.',
    image: 'assets/mc-modal-locationcompare.png',
    imageAlt: 'Location Compare',
};

export const iqMcModalFooterSection: IIqMcModalMciSection = {
    link: 'https://7ba5037f-70f7-4a15-b8a5-36608acb49da.shelf-ssp.com/2-market-conditions-e5770320/using-market-conditions-33ee204f',
};

const GeoTypesSchema = z.enum([
    'COUNTRY',
    'REGION',
    'STATE',
    'X_MKT',
    'MKT',
    'THREEDZ',
]);

const TimeframeSchema = z.enum([
    'THIRTY_DAYS_BACK',
    'EIGHT_DAYS_BACK',
    'PREV_BUSINESS_DAY',
    'CURRENT',
    'EIGHT_DAY_FORECAST',
    '',
]);

const EquipmentTypeSchema = z.enum(['VAN', 'REEFER', 'FLATBED']);

export const McQuerySchema = z.object({
    id: z.string(),
    type: z.literal('area'),
    direction: z.union([z.literal('IN'), z.literal('OUT')]),
    geoType: GeoTypesSchema,
    geoCode: z.string().default(''),
    equipmentType: EquipmentTypeSchema,
    timeframe: TimeframeSchema.default('CURRENT'),
    displayName: z.string().or(z.null()).default(''),
    daysForward: z.string().or(z.null()).default(''),
    forecastDate: z.string().or(z.null()).default(''),
});

export type McQuery = z.infer<typeof McQuerySchema>;